import React, { useState } from 'react'
import ReactPlayer from 'react-player'
import Popup from '../popup/popup'
import StyledButton from '../styledButton'
import {Link} from "gatsby";

const CtaIntroHotel = ({ items }) => {

    const [isOpen, setIsOpen] = useState(false)

    const togglePopup = (e) => {
        e.preventDefault()
        setIsOpen(!isOpen)
    }

    const elements = items.map(function (item) {
        const type = item.internal.type
        switch (type) {
            case "paragraph__remote_video_item":
                return (
                    <>
                        <a key="1" href="#" onClick={e => togglePopup(e)} className="simpleLink">
                            {item.remote_video_item_title}
                        </a>
                        {isOpen && (
                            <Popup
                                content={
                                    item.relationships?.remote_video_item_media
                                        ?.field_media_oembed_video && (
                                            <div className="video-background">
                                                <ReactPlayer
                                                    url={item.relationships.remote_video_item_media.field_media_oembed_video}
                                                    width="100%"
                                                    height="100%"
                                                    config={{
                                                        wistia: {
                                                            options: {
                                                                videoFoam: true,
                                                                volumeControl: true,
                                                                playButton: true,
                                                                autoPlay: false,
                                                                fullscreenButton: true,
                                                                playbar: true,
                                                            },
                                                        },
                                                    }}
                                                />
                                            </div>
                                    )
                                }
                                handleClose={togglePopup}
                            />
                        )}
                    </>
                )
            case "paragraph__link_item":
                return (
                    <Link to={item.link_item_link.url} className="simpleLink" target="_blank">
                        {item.link_item_link.title}
                    </Link>
                )
            case "paragraph__file_item":
                return (
                    <a key="3" href={item.relationships.file_item_media?.relationships.field_media_file.url} target={"_blank"} className="simpleLink">
                        {item.file_item_title}
                    </a>
                )
            default:
                return <></>
        }
    })
    return (
        <div className="hotelGalleryLinks">
            {elements}
        </div>
    )
}

export default CtaIntroHotel